export default __webpack_public_path__ + "static/misrad-rash-5ae6692e87c561b28c72988d04d60738.png";